import PageLoader from '@/ui-library/PageLoader';
import { useAuth } from './auth/AuthProvider';
import { useEffect } from 'react';

export const Logout = () => {
  const { signOut } = useAuth();

  useEffect(() => {
    signOut();
  }, [signOut]);

  return <PageLoader statusText="Logging out..." />;
};
